import { FC } from 'react';
import { AddressType } from '../types';
import { getDisplayName } from '../utils';
import styles from './formats.module.scss';
interface ArabicFormatAddressProps {
  isFullAddress?: boolean;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
}

export const ArabicFormatAddress: FC<ArabicFormatAddressProps> = ({
  isFullAddress,
  address,
  isAddressTypeDisplay,
  translatedAddressType
}) => {
  const {
    address1,
    address2,
    firstName,
    middleName,
    lastName,
    city,
    country,
    email,
    phone,
    state,
    zipCode
  } = address;

  return (
    <div data-testid="address-arabic" className={styles['formats']}>
      {isAddressTypeDisplay && (
        <p className="cat-u-theme-typography-label mb-0" data-cs-encrypt>
          {translatedAddressType}
        </p>
      )}
      <p className="mb-0 exclude-global" data-cs-encrypt>
        {getDisplayName(firstName, middleName, lastName)}
      </p>
      {address1 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address1}
        </p>
      )}
      {address2 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address2}
        </p>
      )}
      {city && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {city}
        </p>
      )}
      {state && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {state}
        </p>
      )}
      {zipCode && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {zipCode}
        </p>
      )}
      {country && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {country}
        </p>
      )}
      {phone && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {phone}
        </p>
      )}
      {email && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {email}
        </p>
      )}
    </div>
  );
};
